export const timeOptions = {
  fillStyle: '#faff00',
  zIndex: 9,
  size: 3,
  animation: {
    type: 'time',
    stepsRange: {
      start: 0,
      end: 80
    },
    // repeat: 0,
    trails: 1,
    // trailsEx: 0.1,
    duration: 2
  },
  draw: 'time'
}

export const circleOptions = {
  fillStyle: '#faff00', // 填充颜色
  lineWidth: 5, // 描边宽度
  max: 30, // 数值最大值范围
  maxSize: 5, // 显示的圆最大半径大小
  zIndex: 2,
  draw: 'bubble'
}

export const cityNameOptions = {
  font: '10px Arial',
  fillStyle: '#fff',
  zIndex: 3,
  offset: {
    x: 0,
    y: 16
  },
  draw: 'text'
}

export const top10boundaryOptions = {
  fillStyle: '#394fdc', // 填充颜色
  strokeStyle: 'rgba(255, 255, 255, 0.1)', // 描边颜色
  lineWidth: 1, // 描边宽度
  zIndex: 0,
  draw: 'simple'
}

export const top30boundaryOptions = {
  fillStyle: '#1d2381', // 填充颜色
  strokeStyle: 'rgba(255, 255, 255, 0.1)', // 描边颜色
  lineWidth: 1, // 描边宽度
  zIndex: 0,
  draw: 'simple'
}

export const mayStyle = {
  styleJson: [
    {
      featureType: 'land',
      elementType: 'geometry',
      stylers: {
        color: '#081535ff'
      }
    },
    {
      featureType: 'building',
      elementType: 'geometry',
      stylers: {
        color: '#2b2b2bff'
      }
    },
    {
      featureType: 'green',
      elementType: 'geometry',
      stylers: {
        color: '#1b1b1bff'
      }
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: {
        color: '#181818FF'
      }
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: {
        color: '#313131FF'
      }
    },
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: {
        color: '#8b8787FF'
      }
    },
    {
      featureType: 'manmade',
      elementType: 'geometry',
      stylers: {
        color: '#1b1b1bff'
      }
    },
    {
      featureType: 'local',
      elementType: 'geometry',
      stylers: {
        lightness: -75,
        saturation: -91
      }
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: {
        visibility: 'off'
      }
    },
    {
      featureType: 'town',
      elementType: 'all',
      stylers: {
        visibility: 'off'
      }
    },
    {
      featureType: 'district',
      elementType: 'all',
      stylers: {
        visibility: 'off'
      }
    },
    {
      featureType: 'city',
      elementType: 'labels.text.fill',
      stylers: {
        color: '#ffffffff'
      }
    },
    {
      featureType: 'city',
      elementType: 'labels.icon',
      stylers: {
        color: '#2da0c6FF',
        visibility: 'off'
      }
    },
    {
      featureType: 'boundary',
      elementType: 'geometry.stroke',
      stylers: {
        color: '#00A0D7FF',
        weight: '1',
        lightness: -29
      }
    }
  ]
}
